import { render, staticRenderFns } from "./ZDMFailureReport.vue?vue&type=template&id=79af74a4&"
import script from "./ZDMFailureReport.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports